import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'

interface FormFieldProps {
    label: string
    htmlFor?: string
    required?: boolean
    hint?: ReactNode
    error?: string
    className?: string
    children: ReactNode
}

const FormField = ({ label, htmlFor, required, hint, error, className, children }: FormFieldProps): ReactNode => {
    return (
        <div className={cn('grid content-start gap-1.5', className)}>
            <Label htmlFor={htmlFor} className='text-[13px] font-medium text-foreground/90'>
                {label}
                {required && <span className='text-destructive' aria-hidden='true'>*</span>}
            </Label>

            {children}

            {error
                ? <p role='alert' className='text-xs font-medium text-destructive'>{error}</p>
                : hint && <p className='text-xs text-muted-foreground'>{hint}</p>}
        </div>
    )
}

export default FormField
